import { OperatingSystem } from "./operating-system.ts";

export enum AppStatus {
  Updated = "updated",
  UpdateAvailable = "update_available",
  Inactive = "inactive",
  NotInstalled = "not_installed",
}

export enum DeviceType {
  Computer = "computer",
  Mobile = "mobile",
  Other = "other",
}

export enum DeviceSource {
  Admin = "admin",
  Merged = "merged",
}

export function osTypeToDeviceType(osType: string | null): DeviceType {
  if (!osType) return DeviceType.Other;
  switch (osType.toLowerCase()) {
    case OperatingSystem.MacOS:
    case OperatingSystem.Windows:
    case OperatingSystem.Linux:
      return DeviceType.Computer;
    case OperatingSystem.Android:
    case OperatingSystem.IOS:
      return DeviceType.Mobile;
    default:
      return DeviceType.Other;
  }
}

export interface DeviceRow {
  source: DeviceSource;
  id: string;
  name: string;
  customTitle: string | null;
  os: OperatingSystem | null;
  owner: string;
  ownerEmail: string;
  appStatus: AppStatus;
  totalTasks: number;
  remainingTasks: number;
}

export interface CreateDevicePayload {
  type: DeviceType;
  os: OperatingSystem | null;
  customTitle: string;
  ownerUserId: number;
}

export type UpdateDevicePayload = { customTitle: string | null };
